class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('back-in-stock', trigger.dataset.productUrl)
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.content.element.innerHTML = myself.innerHTML

        this.setAttribute('aria-hidden', false)
        document.body.classList.toggle('util-SiteOverflowed', true)
      })
      .catch(() => {
        this.setAttribute('aria-hidden', true)
        document.body.classList.toggle('util-SiteOverflowed', false)
      })
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
